import {Component, OnInit} from '@angular/core';
import {AuthService} from "../services/auth.service";
import {Router} from "@angular/router";
import {DataService} from "../services/data.service";
import {User} from "../type/user";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

    constructor(
        private auth: AuthService,
        private dataService: DataService,
        private router: Router
    ) {
    }

    ngOnInit() {
        this.dataService.resetActiveRequestNo();
    }

    onFormSubmit(formData) {
        var data = {
            email: formData.value.email,
            password: formData.value.password,
        };
        this.auth.login(data)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Error: ' + response.json().message);
                    } else {
                        localStorage.setItem('token', response.json().token);
                        localStorage.setItem('permission', JSON.stringify(response.json().permission));
                        this.dataService.refresh();
                        this.router.navigate(['/companies'])
                    }
                },
                (error) => alert('Error: Unable to submit form')
            );
    }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts